export var SIZES = {
  SMALL: "small",
  NORMAL: "normal",
  LARGE: "large"
};
export var TYPES = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SEPARATED: "separated"
};